import { AbstractModel } from './abstract-model';
import { inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ReleasePlatform extends AbstractModel {
  name: string;
  code: string;
  active: boolean;
}
